import { Actions } from '../actions/subscriptions';
import { AxiosError } from 'axios';
import { DeepReadonly } from 'utility-types';
import { ISubscription } from '../interfaces/subscription';

export type State = DeepReadonly<{
  isFetching: boolean;
  subscriptions: ISubscription[] | null;
  error: AxiosError | null;
}>;

const initialState: State = {
  isFetching: false,
  subscriptions: null,
  error: null
};

export function reducer(state: State = initialState, action: Actions): State {
  switch (action.type) {
    case 'FETCH_SUBSCRIPTIONS_REQUEST':
      return {
        ...state,
        isFetching: true
      };
    case 'FETCH_SUBSCRIPTIONS_SUCCESS':
      return {
        isFetching: false,
        subscriptions: action.payload,
        error: null
      };
    case 'FETCH_SUBSCRIPTIONS_FAILURE':
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    default:
      return state;
  }
}
